import React, { useRef } from 'react';
import { css } from 'linaria';
import { LinkWithGAPromoClick } from 'common/components';
import { lowerBoundsBreakpoints, strictBreakpoints } from 'common/styles/breakpoints';
import { usePromoViewEvent } from 'common/hooks';

const seasonStartBathroomBanner = css`
  height: 256px;
  width: 100%;
  margin-bottom: 48px;

  @media (--only-desktop) {
    height: 210px;
  }

  @media (--only-tablet) {
    height: 200px;
  }

  @media (--only-mobile) {
    height: unset;
    margin-bottom: 24px;
  }

  img {
    @media (--from-tablet) {
      height: 100%;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

type SeasonStartHeaderBannerProps = {
  creative: string;
  elemetnBlock: string;
  link: {
    href: string;
    title: string;
  };
  img: {
    alt: string;
    src: string;
    srcT: string;
    srcLd: string;
  };
}

export const SeasonStartHeaderBanner: React.FC<SeasonStartHeaderBannerProps> = ({ creative, elemetnBlock, link, img }) => {
  const refs = useRef<HTMLAnchorElement[]>([]);
  const promotions = [{
    name: elemetnBlock,
    creative,
    position: '1',
  }];

  usePromoViewEvent(refs, elemetnBlock, promotions);

  return (
    <LinkWithGAPromoClick
      className={seasonStartBathroomBanner}
      bannerRefs={refs}
      position={0}
      promotion={promotions[0]}
      elementBlock={elemetnBlock}
      {...link}
    >
      <picture>
        <source srcSet={img.srcLd} media={lowerBoundsBreakpoints['--from-desktop']} />
        <source srcSet={img.srcT} media={strictBreakpoints['--only-tablet']} />
        <img alt={img.alt} src={img.src} />
      </picture>
    </LinkWithGAPromoClick>
  )
};
